// Write your JS code here
import './index.css'

const Contact = () => (
  <div className="route-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/contact-blog-img.png"
      alt="contact"
      className="route-image"
    />
    <h1 className="route-heading">Contact</h1>
  </div>
)

export default Contact
